module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup popup-gene-only",
    staticStyle: {
      "overflow-x": "hidden",
      "padding": "3%"
    }
  }, [_c('div', {}, [_c('div', [_c('div', {
    staticClass: "search-input",
    staticStyle: {
      "width": "85%",
      "float": "left",
      "border-radius": "40px"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "searchGene"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.queryName),
      expression: "queryName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "id": "searchGene",
      "placeholder": "请输入查询基因ID、基因名称、转录本"
    },
    domProps: {
      "value": (_vm.queryName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "searchTr",
    staticStyle: {
      "margin-top": "5vh"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "solid 1px #EFEEF3",
      "padding": "10px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("选择物种")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.radioChecked === ''),
      expression: "this.radioChecked === ''"
    }],
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_c('i', {
    staticClass: "icon-font emkt-icon-gantanhao",
    staticStyle: {
      "font-size": "12px"
    }
  }), _vm._v("\n        查询基因前请先选择物种")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMore),
      expression: "!showMore"
    }],
    staticClass: "icon-font emkt-icon-zhankai",
    staticStyle: {
      "font-size": "13px",
      "color": "#5878FA"
    },
    on: {
      "click": function($event) {
        _vm.showMore = !_vm.showMore
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore),
      expression: "showMore"
    }],
    staticClass: "icon-font emkt-icon-shouqi",
    staticStyle: {
      "font-size": "13px",
      "color": "#5878FA"
    },
    on: {
      "click": function($event) {
        _vm.showMore = !_vm.showMore
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px"
    },
    attrs: {
      "id": "taxName"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || (_vm.radioChecked === '9606' ||
        _vm.radioChecked === '10116' || _vm.radioChecked === '10090' || _vm.radioChecked === '')),
      expression: "showMore || (radioChecked === '9606'\n      || radioChecked === '10116' || radioChecked === '10090' ||radioChecked === '')"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "33%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '9606'
    },
    attrs: {
      "for": "human"
    }
  }, [_vm._v("人类 " + _vm._s(_vm.human))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "human",
      "value": "9606"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || (_vm.radioChecked === '9606' ||
        _vm.radioChecked === '10116' || _vm.radioChecked === '10090' || _vm.radioChecked === '')),
      expression: "showMore || (radioChecked === '9606'\n      || radioChecked === '10116' || radioChecked === '10090' ||radioChecked === '')"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "32%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10116'
    },
    attrs: {
      "for": "rat"
    }
  }, [_vm._v("大鼠 " + _vm._s(_vm.rat))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "rat",
      "value": "10116"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || (_vm.radioChecked === '9606' ||
        _vm.radioChecked === '10116' || _vm.radioChecked === '10090' || _vm.radioChecked === '')),
      expression: "showMore || (radioChecked === '9606'\n      || radioChecked === '10116' || radioChecked === '10090' ||radioChecked === '')"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "32%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10090'
    },
    attrs: {
      "for": "mouse"
    }
  }, [_vm._v("小鼠 " + _vm._s(_vm.mouse))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "mouse",
      "value": "10090"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10123'),
      expression: "showMore || radioChecked === '10123'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10123'
    },
    attrs: {
      "for": "pig"
    }
  }, [_vm._v("猪 " + _vm._s(_vm.pig))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "pig",
      "value": "10123"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10125'),
      expression: "showMore || radioChecked === '10125'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10125'
    },
    attrs: {
      "for": "rabbit"
    }
  }, [_vm._v("兔子 " + _vm._s(_vm.rabbit))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "rabbit",
      "value": "10125"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10124'),
      expression: "showMore || radioChecked === '10124'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10124'
    },
    attrs: {
      "for": "sheep"
    }
  }, [_vm._v("绵羊 " + _vm._s(_vm.sheep))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "sheep",
      "value": "10124"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10120'),
      expression: "showMore || radioChecked === '10120'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10120'
    },
    attrs: {
      "for": "rice"
    }
  }, [_vm._v("水稻 " + _vm._s(_vm.rice))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "rice",
      "value": "10120"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10121'),
      expression: "showMore || radioChecked === '10121'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "32%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10121'
    },
    attrs: {
      "for": "zebrafish"
    }
  }, [_vm._v("斑马鱼 " + _vm._s(_vm.zebrafish))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "zebrafish",
      "value": "10121"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10118'),
      expression: "showMore || radioChecked === '10118'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "32%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10118'
    },
    attrs: {
      "for": "Gallus_gallus"
    }
  }, [_vm._v("鸡 " + _vm._s(_vm.Gallus_gallus))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "Gallus_gallus",
      "value": "10118"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10119'),
      expression: "showMore || radioChecked === '10119'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "33%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10119'
    },
    attrs: {
      "for": "thale_cress"
    }
  }, [_vm._v("拟南芥 " + _vm._s(_vm.thale_cress))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "thale_cress",
      "value": "10119"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10128'),
      expression: "showMore || radioChecked === '10128'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "34%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10128'
    },
    attrs: {
      "for": "yeast"
    }
  }, [_vm._v("酵母 " + _vm._s(_vm.yeast))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "yeast",
      "value": "10128"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10127'),
      expression: "showMore || radioChecked === '10127'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "64%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10127'
    },
    attrs: {
      "for": "African_clawed_frog"
    }
  }, [_vm._v("非洲爪娃 " + _vm._s(_vm.African_clawed_frog))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "African_clawed_frog",
      "value": "10127"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10122'),
      expression: "showMore || radioChecked === '10122'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10122'
    },
    attrs: {
      "for": "fruit_fly"
    }
  }, [_vm._v("果蝇 " + _vm._s(_vm.fruit_fly))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "fruit_fly",
      "value": "10122"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10126'),
      expression: "showMore || radioChecked === '10126'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "52%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10126'
    },
    attrs: {
      "for": "domestic_silkworm"
    }
  }, [_vm._v("家蚕 " + _vm._s(_vm.domestic_silkworm))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "domestic_silkworm",
      "value": "10126"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore || _vm.radioChecked === '10117'),
      expression: "showMore || radioChecked === '10117'"
    }],
    staticClass: "searchRadioBox",
    staticStyle: {
      "width": "15%"
    }
  }, [_c('label', {
    staticClass: "searchBox default",
    class: {
      selected: _vm.radioChecked === '10117'
    },
    attrs: {
      "for": "others"
    }
  }, [_vm._v(_vm._s(_vm.others))]), _vm._v(" "), _c('input', {
    staticClass: "searchRadio input",
    attrs: {
      "type": "radio",
      "id": "others",
      "value": "10117"
    },
    on: {
      "click": _vm.clickRadio
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMore && (_vm.radioChecked !== '9606' &&
        _vm.radioChecked !== '10116' && _vm.radioChecked !== '10090' && _vm.radioChecked !== '')),
      expression: "!showMore &&(radioChecked !== '9606'\n      && radioChecked !== '10116' && radioChecked !== '10090' && radioChecked !== '')"
    }],
    staticStyle: {
      "font-size": "13px",
      "color": "#5878FA",
      "margin-left": "20px"
    },
    on: {
      "click": function($event) {
        _vm.showMore = !_vm.showMore
      }
    }
  }, [_vm._v("\n        选择其它物种\n        "), _c('i', {
    staticClass: "icon-font emkt-icon-zhankai",
    staticStyle: {
      "font-size": "12px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMore && (_vm.radioChecked === '9606' ||
        _vm.radioChecked === '10116' || _vm.radioChecked === '10090' || _vm.radioChecked === '')),
      expression: "!showMore && (radioChecked === '9606'\n      || radioChecked === '10116' || radioChecked === '10090' || radioChecked === '')"
    }],
    staticStyle: {
      "font-size": "13px",
      "color": "#5878FA"
    },
    on: {
      "click": function($event) {
        _vm.showMore = !_vm.showMore
      }
    }
  }, [_vm._v("\n          更多物种\n          "), _c('i', {
    staticClass: "icon-font emkt-icon-zhankai",
    staticStyle: {
      "font-size": "12px"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMore),
      expression: "showMore"
    }],
    staticStyle: {
      "font-size": "13px",
      "color": "#5878FA"
    },
    on: {
      "click": function($event) {
        _vm.showMore = !_vm.showMore
      }
    }
  }, [_vm._v("\n          点击收起\n          "), _c('i', {
    staticClass: "icon-font emkt-icon-shouqi",
    staticStyle: {
      "font-size": "12px"
    }
  })])])])]), _vm._v(" "), (!_vm.showMatchData) ? _c('div', [_c('h6', [_vm._v("注意事项：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": ".6rem",
      "margin-left": "1rem",
      "margin-right": "1rem"
    }
  }, [_vm._v("1.数据来源为NCBI refseq数据库，mirBase数据库。")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.showMatchData) ? _c('div', _vm._l((_vm.queryRes), function(searchData, index) {
    return _c('div', [_c('div', {
      staticClass: "searchTr"
    }, [_c('div', {
      class: _vm.close ? 'close-popup' : '',
      staticStyle: {
        "padding": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.searchTarget(searchData, index)
        }
      }
    }, [_c('div', [_c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "60%"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "16px",
        "font-weight": "bold",
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(searchData.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "10px",
        "color": "#979797"
      }
    }, [_vm._v("codeSize:" + _vm._s(searchData.genes[0].cdsSize))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#979797",
        "font-size": "10px",
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "white-space": "nowrap"
      }
    }, [_c('span', [_vm._v(_vm._s(searchData.genes[0].matched))]), _vm._v(" "), (searchData.genes[0].ttttflag === 0) ? _c('span', [_vm._v("连续4T：否")]) : _vm._e(), _vm._v(" "), (searchData.genes[0].ttttflag === 1) ? _c('span', [_vm._v("连续4T：是")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "width": "40%"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "41px",
        "height": "70px",
        "float": "right",
        "margin": "-10px -10px 0 0"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          searchData.open = !searchData.open
        }
      }
    }, [((searchData.genes.length > 1) && !searchData.open) ? _c('i', {
      staticClass: "icon-font emkt-icon-zhankai",
      staticStyle: {
        "position": "relative",
        "float": "right",
        "top": "22px",
        "right": "12px",
        "color": "#5878FA",
        "font-size": "16px",
        "z-index": "999"
      }
    }) : (searchData.open) ? _c('i', {
      staticClass: "icon-font emkt-icon-shouqi",
      staticStyle: {
        "position": "relative",
        "float": "right",
        "top": "22px",
        "right": "12px",
        "color": "#5878FA",
        "font-size": "16px",
        "z-index": "999"
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right",
        "text-align": "end",
        "margin-top": "15px",
        "font-size": "12px",
        "width": "75%"
      }
    }, [_c('div', {
      staticClass: "sub-title"
    }, [_vm._v(_vm._s(searchData.genes[0].subtitle))]), _vm._v(" "), (searchData.genes[0].recommended) ? _c('div', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("推荐转录本")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (searchData.text !== '' && searchData.open) ? _c('div', _vm._l((searchData.genes), function(gens, indexs) {
      return _c('div', {
        class: _vm.close ? 'close-popup' : '',
        on: {
          "click": function($event) {
            return _vm.searchTarget(gens, indexs)
          }
        }
      }, [(indexs !== 0) ? _c('div', {
        staticStyle: {
          "border-top": "#EFEEF3 0.5px solid",
          "padding": "10px"
        }
      }, [_c('div', [_c('div', {
        staticStyle: {
          "width": "100%"
        }
      }, [_c('span', {
        staticStyle: {
          "font-size": "16px",
          "font-weight": "bold",
          "margin-right": "5px",
          "float": "left"
        }
      }, [_vm._v(_vm._s(searchData.title))]), _vm._v(" "), _c('span', {
        staticStyle: {
          "font-size": "10px",
          "color": "#979797"
        }
      }, [_vm._v("codeSize:" + _vm._s(gens.cdsSize))])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "color": "#979797",
          "font-size": "10px",
          "width": "60%",
          "overflow": "hidden",
          "text-overflow": "ellipsis",
          "white-space": "nowrap"
        }
      }, [_c('span', [_vm._v(_vm._s(gens.matched))]), _vm._v(" "), (searchData.ttttflag === 0) ? _c('span', [_vm._v("连续4T：否")]) : _vm._e(), _vm._v(" "), (searchData.ttttflag === 1) ? _c('span', [_vm._v("连续4T：是")]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right",
          "position": "relative",
          "top": "-35px",
          "font-size": "12px",
          "text-align": "end",
          "width": "40%"
        }
      }, [_c('div', {
        staticClass: "sub-title"
      }, [_vm._v(_vm._s(gens.subtitle))]), _vm._v(" "), (gens.recommended) ? _c('div', {
        staticStyle: {
          "color": "red"
        }
      }, [_vm._v("推荐转录本")]) : _vm._e()])]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), _c('div')])])
  }), 0) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "15%",
      "float": "right",
      "text-align": "center",
      "font-size": "14px",
      "color": "#979797",
      "padding-top": "5px"
    }
  }, [_c('span', {
    staticClass: "close-popup"
  }, [_vm._v("取消")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": ".6rem",
      "margin-left": "1rem",
      "margin-right": "1.1rem"
    }
  }, [_vm._v("2.NCBI中refseq数据库\n      "), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("NM、XM")]), _vm._v("开头的accession为\n      "), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("编码基因")]), _vm._v("；\n      "), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("NR、XR")]), _vm._v("开头的accession为\n      "), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("非编码基因")]), _vm._v("。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": ".6rem",
      "margin-left": "1rem",
      "margin-right": "1rem"
    }
  }, [_vm._v("3."), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("pre-miRNA为MicroUp")]), _vm._v("基因类型，\n      "), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("mature miRNA为MicroDown")]), _vm._v("基因类型；")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": ".6rem",
      "margin-left": "1rem",
      "margin-right": "1rem"
    }
  }, [_vm._v("5.如果您在基因选择上遇到任何疑问，请返回上一步点击左下角\n      "), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("“在线客服”")]), _vm._v("寻求帮助；")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7fdea44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/SearchGeneBox.vue
// module id = 1743
// module chunks = 8